import { createFileRoute } from "@tanstack/react-router";
import { SettingsGeneralPage } from "@/pages/SettingsGeneralPage";

export const Route = createFileRoute("/_app/settings/")({
  component: SettingsGeneralPage,
});
